angular.module('acme.view.application.importExport.exportJobExecution.directives.exportJobExecutionOutputs', [
  'acme.common.service.utils'
])
.directive('exportJobExecutionOutputs', exportJobExecutionOutputs)
.controller('ExportJobExecutionOutputsController', ExportJobExecutionOutputsController);

function exportJobExecutionOutputs() {
  return {
    restrict: 'A',
    replace: true,
    scope: {},
    controller: 'ExportJobExecutionOutputsController',
    controllerAs: '$ctrl',
    templateUrl: 'views/application/views/importExport/exportJobExecution/directives/exportJobExecutionOutputs/exportJobExecutionOutputs.tpl.html',
    bindToController: {
      outputs: '<'
    }
  };
}

/**
 * Controller responsible for an Export Job's Job Execution's Output(s) / download(s)
 * @class ExportJobExecutionOutputsController
 * @constructor
 * @param $window
 * @param {Object} UtilsService - utilities function helpers
 * @param {Object} ImportExportsApiService
 * @return {ExportJobExecutionOutputsController} - Class instance
 */
function ExportJobExecutionOutputsController($window, UtilsService, ImportExportsApiService) {
  Object.assign(this, {
    $window: $window,
    UtilsService: UtilsService,
    ImportExportsApiService: ImportExportsApiService
  });
}

/**
 * Angular lifecycle method $onInit
 * Ran when bindings are ready
 * @public
 * @memberOf ExportJobExecutionOutputsController
 * @return {Undefined} -
 */
ExportJobExecutionOutputsController.prototype.$onInit = function () {
  this.vm = this._getVm(this);
};

/**
 * @typedef $changesObj
 * @type {Object}
 * @property {*} currentValue - The actual value
 * @property {*} previousValue - The previous value
 */

/**
 * Angular lifecycle method $onChanges
 * Ran when watched bindings change
 * @public
 * @memberOf ExportJobExecutionOutputsController
 * @param {Object.<String, $changesObj>} changes - Angular changesObj
 * @return {Undefined} -
 */
ExportJobExecutionOutputsController.prototype.$onChanges = function (changes) {
  var update = this.UtilsService.removeUndefinedProperties(changes, true);

  Object.assign(this, update);
  this.vm = this._getVm(this);
};

/**
 * Computes the viewModel and return it
 * @memberOf ExportJobExecutionOutputsController
 * @private
 * @param {Object=} initialData - initial data used as a basis for the model
 *                                Returns default values if no data is passed
 * @return {Object} - The view model
 */
ExportJobExecutionOutputsController.prototype._getVm = function (initialData) {
  var _data = initialData || {},
    outputs = _data.outputs || [];

  return {
    outputs: outputs
  };
};

ExportJobExecutionOutputsController.prototype.getDownloadUrl = function (id) {
  return this.ImportExportsApiService.getDownloadUrl(id);
};

ExportJobExecutionOutputsController.prototype.downloadOutput = function ($event, id) {
  $event.preventDefault();
  this.$window.open(this.getDownloadUrl(id));
};

ExportJobExecutionOutputsController.$inject = [
  '$window',
  'UtilsService',
  'ImportExportsApiService'
];
